<template>
  <v-sheet class="pb-3" :color="$vuetify.theme.dark ? '#1A2A3E' : '#E8F1F8'">
    <apexChart width="100%" height="338px" type="bar" :options="chartOptions" :series="series" class="liveTradeChart" />
  </v-sheet>
</template>

<script>
export default {
  name: 'ProfitLossChart',
  props: {
    trades: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
          height: '338px',
          theme: 'dark',
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          }
        },
        xaxis: {
          labels: {
            style: {
              colors: Array(31).fill('#708AA7')
            },
            rotate: -45,
            rotateAlways: false
          },
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: ['#708AA7']
            },
            formatter: (value) => Math.abs(value).toFixed(2)
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '40%',
            distributed: false,
            borderRadius: 2
          }
        },
        colors: ['#039de9', '#647E98'],
        dataLabels: {
          enabled: false
        },
        grid: {
          show: false
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Profit', 'Loss'],
          labels: {
            colors: ['#647E98'],
            useSeriesColors: false
          },
          markers: {
            fillColors: ['#039de9', '#647E98'],
            radius: 12
          }
        },
        tooltip: {
          theme: 'dark',
          y: {
            formatter: (value) => Math.abs(value).toFixed(2)
          }
        }
      },
      series: [
        {
          name: 'Profit',
          data: []
        },
        {
          name: 'Loss',
          data: []
        }
      ]
    }
  },
  watch: {
    trades: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.updateChart(newVal)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    updateChart(chartData) {
      if (!chartData || !Array.isArray(chartData)) return

      const isYearView = chartData.length > 0 && chartData[0].date?.length === 3

      // Transform data into separate profit and loss series
      const transformedData = chartData.map(item => ({
        x: item.date,
        profit: item.profit >= 0 ? Math.abs(item.profit) : 0,
        loss: item.profit < 0 ? Math.abs(item.profit) : 0
      }))

      this.series = [
        {
          name: 'Profit',
          data: transformedData.map(item => ({
            x: item.x,
            y: item.profit
          }))
        },
        {
          name: 'Loss',
          data: transformedData.map(item => ({
            x: item.x,
            y: item.loss
          }))
        }
      ]

      // Update chart options based on view type
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          labels: {
            ...this.chartOptions.xaxis.labels,
            rotate: isYearView ? 0 : -45,
            rotateAlways: !isYearView
          }
        },
        plotOptions: {
          ...this.chartOptions.plotOptions,
          bar: {
            ...this.chartOptions.plotOptions.bar,
            columnWidth: isYearView ? '60%' : '40%'
          }
        }
      }
    }
  }
}
</script>